import type { DisconnectedCallUsecase } from '@usecases/disconnected-call.usecase';

import type { BaseController } from '@infra/controllers/base.controller';

export type DisconnectedCallInput = void;

export type DisconnectedCallOutput = void;

export class DisconnectedCallController
  implements BaseController<DisconnectedCallInput, DisconnectedCallOutput>
{
  constructor(private usecase: DisconnectedCallUsecase) {}

  async handle(): Promise<DisconnectedCallOutput> {
    await this.usecase.run();
  }
}
